import styled from "styled-components";
import { ContinueButton } from "../../../Components/SignupContainer.styles";

export const FooterRightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 2rem;
`;

export const ContinueButtonStyled = styled(ContinueButton)`
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

export const TaxCardWrapper = styled.div`
  padding: 20px;
  background: #fafafa;
  border-radius: 8px;
  margin-top: 32px;
`;
